import { setValue } from './input';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLInputElement {
        setValue(value: any): HTMLInputElement;
    }
}

// ----------------------------------------------------------------------------

HTMLInputElement.prototype.setValue = function (value: any): HTMLInputElement {
    setValue(this, value);

    return this;
};
